import { render, staticRenderFns } from "./AnotherAuthorityList.vue?vue&type=template&id=67ddd6c8&scoped=true&"
import script from "./AnotherAuthorityList.vue?vue&type=script&lang=js&"
export * from "./AnotherAuthorityList.vue?vue&type=script&lang=js&"
import style0 from "./AnotherAuthorityList.vue?vue&type=style&index=0&id=67ddd6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddd6c8",
  null
  
)

export default component.exports